var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5866 2.66669H10.4133C5.55996 2.66669 2.66663 5.56002 2.66663 10.4134V21.5867C2.66663 25.3334 4.38663 27.9067 7.41329 28.88C8.29329 29.1867 9.30663 29.3334 10.4133 29.3334H21.5866C22.6933 29.3334 23.7066 29.1867 24.5866 28.88C27.6133 27.9067 29.3333 25.3334 29.3333 21.5867V10.4134C29.3333 5.56002 26.44 2.66669 21.5866 2.66669ZM27.3333 21.5867C27.3333 24.44 26.2133 26.24 23.96 26.9867C22.6666 24.44 19.6 22.6267 16 22.6267C12.4 22.6267 9.34663 24.4267 8.03996 26.9867H8.02663C5.79996 26.2667 4.66663 24.4534 4.66663 21.6V10.4134C4.66663 6.65335 6.65329 4.66669 10.4133 4.66669H21.5866C25.3466 4.66669 27.3333 6.65335 27.3333 10.4134V21.5867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.045 18.2489L20.02 17.2239C20.5538 16.4231 20.8635 15.4621 20.8635 14.4264C20.8635 11.6076 18.5785 9.33331 15.7704 9.33331C12.9623 9.33331 10.6666 11.6183 10.6666 14.4264C10.6666 17.2345 12.9516 19.5195 15.7597 19.5195C16.7954 19.5195 17.7564 19.2099 18.5572 18.676L19.5822 19.701C19.7851 19.9039 20.052 20 20.3083 20C20.5752 20 20.8421 19.9039 21.0343 19.701C21.4401 19.306 21.4401 18.6546 21.045 18.2489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreening);
export default __webpack_public_path__ + "static/media/screening.d09cd60e9b400299a17fe2203a2a1bf6.svg";
export { ForwardRef as ReactComponent };